module.exports = __webpack_public_path__ + "static/img/15.cd6f839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/15.png
// module id = Cb4m
// module chunks = 0